import React, { useCallback, useEffect } from 'react';
import app from 'srcJs/App';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { bindActionCreators } from 'redux';
import { appUserLoadBalance } from 'moduleBase/actions/user-load-balance';
import { BalanceObserver } from 'moduleBase/components/observers/BalanceObserver';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import { MESSAGE_INVOICE_NOTIFY, MESSAGE_TYPE_PROJECT_CREATE, MESSAGE_TYPE_PROJECT_DELETE } from 'srcJs/components/realtime-notification/constants/constants';
import { userLoadData } from 'moduleUser/actions/load-data';
import { menuBalanceLoad } from 'moduleBase/modules/menu-balance/actions/load';

var UserObserver = function UserObserver(_ref) {
  var userLoadBalance = _ref.userLoadBalance,
      loadData = _ref.loadData,
      loadMenuBalance = _ref.loadMenuBalance;
  var loadBalance = useCallback(function () {
    userLoadBalance().then(function (response) {
      app.getUser().setBalance(response.data.balance);
    });
  }, []);

  var loadDataWrapper = function loadDataWrapper() {
    loadData().then(function (response) {
      app.getUser().setData(response.data.user);
    });
  };

  var handlerProjectCreate = useCallback(function (message) {
    if (!message.isFirst) {
      return;
    }

    loadDataWrapper();
  }, []);
  var handlerProjectDelete = useCallback(function (message) {
    if (!message.isLast) {
      return;
    }

    loadDataWrapper();
  }, []);
  var handlerInvoiceNotify = useCallback(function () {
    loadDataWrapper();
    loadMenuBalance();
  }, []);
  useEffect(function () {
    realtimeNotification.addListener(MESSAGE_TYPE_PROJECT_CREATE, handlerProjectCreate);
    realtimeNotification.addListener(MESSAGE_TYPE_PROJECT_DELETE, handlerProjectDelete);
    realtimeNotification.addListener(MESSAGE_INVOICE_NOTIFY, handlerInvoiceNotify);
    return function () {
      realtimeNotification.removeListener(handlerProjectCreate);
      realtimeNotification.removeListener(handlerProjectDelete);
      realtimeNotification.removeListener(handlerInvoiceNotify);
    };
  }, []);
  return /*#__PURE__*/React.createElement(BalanceObserver, {
    callback: loadBalance
  });
};

export default connect(UserObserver, {
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      userLoadBalance: appUserLoadBalance,
      loadData: userLoadData,
      loadMenuBalance: menuBalanceLoad
    }, dispatch);
  }
});